import { ISession } from '@utils';
import { setUser } from '@utils/auth';
import { getUserId } from '@/api/user';

const tokenKey = 'Outside-Auth-Info';

export function getOutsideAuth(val) {
  let user = ISession(tokenKey);
  try {
    user && (user = JSON.parse(user));
  } catch (error) {
    user = null;
  }

  return user || null;
}

export function setOutsideAuth(val) {
  const { unionId, token, appId, preOrderId } = val;
  if (unionId && token && appId && preOrderId) {
    let user = JSON.stringify({
      unionId,
      token,
      appId,
      preOrderId,
    });
    ISession(tokenKey, user);
    return user;
  }
}

export async function checkOutsideAuth(val) {
  const res = setOutsideAuth(val);
  if (res) {
    // 获取用户id, 覆盖登陆信息
    const u =  await getUserId();
    if (u.code === 10000) {
      setUser(JSON.stringify({
        uid: u.data,
      }));
    }
    return u.data;
  }
}

